export default __webpack_public_path__ + "static/media/hht2_ep10_timeline_q04_a.0a85d01e.png";